import React from 'react';
import { Box } from '@mui/material';
import { statusColor, humanizeStatus } from './portalStyles';

// Dot-pill status indicator — the app-standard treatment (colored dot + muted
// label on a soft grey pill). Pass an explicit `label` to preserve wording;
// otherwise the status enum is humanized.
export default function PortalStatusPill({ status, label, color }) {
    const dot = color || statusColor(status);
    const text = label != null ? label : humanizeStatus(status);
    return (
        <Box
            component="span"
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 0.9,
                px: 1.25,
                py: 0.4,
                borderRadius: '999px',
                backgroundColor: '#f1f5f9',
                whiteSpace: 'nowrap',
            }}
        >
            <Box component="span" sx={{ width: 7, height: 7, borderRadius: '50%', backgroundColor: dot, flexShrink: 0 }} />
            <Box component="span" sx={{ fontSize: 12, fontWeight: 600, color: '#475569', lineHeight: 1.6 }}>
                {text}
            </Box>
        </Box>
    );
}
